import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";

import {MaterialCommonModule} from "src/app/material-modules/material-common.module";
import {CadastrarRimComponent} from "./cadastrar-rim/cadastrar-rim.component";
import {RimRoutingModule} from "./rim-routing.module";
import {RimComponent} from "./rim.component";
import {ComboContratoModule} from "../common/combo-contrato/combo-contrato.module";
import {ComboUnidadeModule} from "../common/combo-unidade/combo-unidade.module";
import {CapituloRimComponent} from "./cadastrar-rim/capitulo-rim/capitulo-rim.component";
import {ConteudoRimComponent} from "./cadastrar-rim/conteudo-rim/conteudo-rim.component";
import {ComboConsultaBancoModule} from "../common/combo-consulta-banco/combo-consulta-banco.module";
import {ComboTipoConteudoRimModule} from "../common/combo-tipo-conteudo-rim/combo-tipo-conteudo-rim.module";
import {ConteudoTabelaRimComponent} from "./cadastrar-rim/conteudo-tabela-rim/conteudo-tabela-rim.component";
import {ConteudoParagrafoRimComponent} from "./cadastrar-rim/conteudo-paragrafo-rim/conteudo-paragrafo-rim.component";
import {ConteudoAnexoRimComponent} from "./cadastrar-rim/conteudo-anexo-rim/conteudo-anexo-rim.component";
import {BotoesRelatorioRimComponent} from "./botao-relatorio/botao-relatorio.component";
import {CKEditorModule} from "ng2-ckeditor";
import {MatMenuModule} from "@angular/material/menu";
import {
    LarguraColunaTabelaDialogComponent
} from "./cadastrar-rim/editar-largura-coluna-tabela-dialog/largura-coluna-tabela-dialog.component";
import {
    EditarCabecalhoTabelaDialogComponent
} from "./cadastrar-rim/editar-cabecalho-tabela-dialog/editar-cabecalho-tabela-dialog.component";

@NgModule({
    declarations: [
        RimComponent,
        CadastrarRimComponent,
        CapituloRimComponent,
        ConteudoRimComponent,
        ConteudoTabelaRimComponent,
        ConteudoParagrafoRimComponent,
        ConteudoAnexoRimComponent,
        BotoesRelatorioRimComponent,
        LarguraColunaTabelaDialogComponent,
        EditarCabecalhoTabelaDialogComponent
    ],
    imports: [
        CommonModule,
        RimRoutingModule,
        MaterialCommonModule,
        ComboContratoModule,
        ComboUnidadeModule,
        ComboConsultaBancoModule,
        ComboTipoConteudoRimModule,
        CKEditorModule,
        MatMenuModule
    ],
})
export class RimModule {
}
